import { Box, Stack, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const PictureFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const signedResourceUrl = currentBlock?.signedResourceUrl;

  return (
    <>
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Stack gap={0.5}>
          {label && (
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "regular",
                color: "text.primary",
              }}
            >
              {label}
            </Typography>
          )}
          {signedResourceUrl && (
            <Box>
              <img
                src={signedResourceUrl}
                alt="preview"
                style={{
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          )}
        </Stack>
      </Box>
    </>
  );
};
export default PictureFieldPreview;
